<ng-template #dateSelection let-filter="filter">
	<mat-form-field class="table-menu__date-selector">
		<mat-label>
			{{filter.filterNameTranslationInfo.defaultText | translate : filter.filterNameTranslationInfo.token : filter.filterNameTranslationInfo.scope}}
		</mat-label>
		<input appLocalizedDatepicker (dateChange)="onDateChange(filter, $event.value)" matInput [matDatepicker]="picker">
		<mat-datepicker-toggle matIconSuffix [for]="picker" />
		<mat-datepicker #picker />
</mat-form-field>
</ng-template>


<app-side-menu-content>
	@if(tableFilterGroups().length === 0){
		<!--todo?: Placeholder-->
	}
	@else {
			@for(filterGroup of tableFilterGroups(); track $index){
			<app-side-menu-group>
				<app-side-menu-group-title>
				{{filterGroup.groupNameTranslationInfo.defaultText | translate : filterGroup.groupNameTranslationInfo.token : filterGroup.groupNameTranslationInfo.scope}}
				</app-side-menu-group-title>
				<app-side-menu-group-content >
					@if(filterGroup.children){
						@switch (filterGroup.groupType) {
							@case(filterGroupTypes.SINGLE_SELECT){
								<mat-chip-listbox >
									@for(filter of filterGroup.children; track $index){
										@if(filter.filterValue.filterType === filterTypes.SELECT){
													<mat-chip-option [selected]="filter.filterValue.isSelected" (selectionChange)="onSelectChange(filter, $event, filterGroup)" [value]="filter">
														@if(filter.filterNameTranslationInfo){
																{{filter.filterNameTranslationInfo.defaultText | translate : filter.filterNameTranslationInfo.token : filter.filterNameTranslationInfo.scope}}
														}
														@else if(filter.filterName){
															{{filter.filterName}}
														}
									    </mat-chip-option>
										 }
								}
								</mat-chip-listbox>
							} 
							@case(filterGroupTypes.MULTI_SELECT){
								<mat-chip-listbox [multiple]="true">
									@for(filter of filterGroup.children; track $index){
									@if(filter.filterValue.filterType === filterTypes.SELECT){
													<mat-chip-option [selected]="filter.filterValue.isSelected" (selectionChange)="onSelectChange(filter, $event)" [value]="filter">
										   	@if(filter.filterNameTranslationInfo){
																{{filter.filterNameTranslationInfo.defaultText | translate : filter.filterNameTranslationInfo.token : filter.filterNameTranslationInfo.scope}}
														}
														@else if(filter.filterName){
															{{filter.filterName}}
														}
									    </mat-chip-option>
										 }
								}
								</mat-chip-listbox>
							}
							@case(filterGroupTypes.TIMESPAN){
								@let startDateFilter = findFilterByType(filterGroup, filterTypes.START_DATE);
								@let endDateFilter = findFilterByType(filterGroup, filterTypes.END_DATE);

								<section class="table-menu__date-selection">
									@if(startDateFilter){
										<ng-container
										[ngTemplateOutlet]="dateSelection"
										[ngTemplateOutletContext]="{filter: startDateFilter}">
									<!--eslint-disable-next-line @angular-template/prefer-self-closing-tags-->
									</ng-container>
									}
									@if(endDateFilter){
										<ng-container
										[ngTemplateOutlet]="dateSelection"
										[ngTemplateOutletContext]="{filter: endDateFilter}">
										<!--eslint-disable-next-line @angular-template/prefer-self-closing-tags-->
									</ng-container>
									}
								</section>
						}
					}
				}
				</app-side-menu-group-content>
			</app-side-menu-group>
		}
	}
</app-side-menu-content>
